module.exports = __webpack_public_path__ + "img/Bowl-Grilled-Chicken.26145e81.jpg";